/* eslint-disable */
export const memberships = '/memberships';
export const membership = (membershipId: number) =>
  `${memberships}/${membershipId}`;
export const doctorMembership = (membershipId:number,doctorId:number)=>
  `${membership(membershipId)}/doctor/${doctorId}`;

